module.exports = __webpack_public_path__ + "img/Illustration-solution.c8534a0.png";